import { LocationMarkerPopover } from "@/components/r3f/utils/location-marker-popover";
import { PhotogrammetryScanPreviewPopover } from "@/components/r3f/utils/photogrammetry-scan-preview-popover";
import { PlaceholderPreview } from "@/components/r3f/utils/placeholder-preview";
import { IElementWaypoint } from "@/hooks/use-placeholders";
import { isIElementPhotogrammetryScan } from "@/types/ielement-extra-types";
import {
  isIElementImg2d,
  isIElementImg360,
  isIElementRoomSection,
} from "@faro-lotv/ielement-types";
import type { JSX } from "react";

type WaypointPreviewProps = {
  /** The waypoint place to preview */
  placeholder: IElementWaypoint;

  /** Called when the pointer enters or leaves the preview popover itself. */
  onPreviewHoverChange?(isHovered: boolean): void;
};

/**
 * @returns image preview for Pano360/2DPhoto, or popover for location marker
 */
export function WaypointPreview({
  placeholder,
  onPreviewHoverChange,
}: WaypointPreviewProps): JSX.Element | null {
  if (isIElementImg360(placeholder) || isIElementImg2d(placeholder)) {
    return (
      <PlaceholderPreview
        placeholder={placeholder}
        onPreviewHoverChange={onPreviewHoverChange}
      />
    );
  }

  if (isIElementRoomSection(placeholder)) {
    return <LocationMarkerPopover locationMarker={placeholder} />;
  }

  if (isIElementPhotogrammetryScan(placeholder)) {
    return (
      <PhotogrammetryScanPreviewPopover photogrammetryScan={placeholder} />
    );
  }

  return null;
}
